export let LIGHT_BLACK = "#2e2e2e"
export let DEEP_SKY_BLUE = "#0b9fd0"
export let NAVY = '#011e3b'